<template>
  <v-app id="inspire">
    <loading />
    <confirm ref="confirm"></confirm>

    <v-navigation-drawer
      v-model="navigation.shown"
      v-if="$route.path !== '/home/dashboard'"
    >
      <navBar :navigation = "navigation" />
    </v-navigation-drawer>

    <v-app-bar>
      <v-container fluid>
        <v-row>
          <v-col v-if="$route.path !== '/module/documents'" :md="$route.path !== '/home/dashboard' ? '1' : '2'" cols="1">
            <v-app-bar-nav-icon
              @click="navigation.shown = !navigation.shown"
              v-if="$route.path !== '/home/dashboard' && $route.path !== '/module/documents'"
            ></v-app-bar-nav-icon>
            <div class="text-center" v-else>
                <img :src="getCurrentCompany?.logo_thumb ? getFileServerUrl + getCurrentCompany?.logo_thumb : '@/assets/image/logo.png'" class="logo"/>
            </div>
          </v-col>

          <v-col
            md="1"
            cols=""
            class="align-self-center d-none d-md-block pa-0 text-center"
            v-if="$route.path === '/module/documents'"
          >
            <v-icon
              title="Step Backward"
              color="blue-grey-lighten-1"
              @click="$router.go(-1)"
              icon="mdi mdi-step-backward"
            ></v-icon>
          </v-col>

          <v-col
            :md="$route.path !== '/home/dashboard' && $route.path === '/module/documents' ? '3' : '2'"
            cols="6"
            class="align-self-center d-none d-md-block pa-0"
          >
            <v-app-bar-title><breadCrumbs></breadCrumbs></v-app-bar-title>
          </v-col>

          <v-col v-if="$route.path !== '/home/dashboard'" md="1" cols="1"></v-col>

          <v-col
            md="1"
            cols=""
            class="align-self-center d-none d-md-block pa-0 text-center"
            v-if="$route.path !== '/module/documents'"
          >
            <v-icon
              title="Step Backward"
              color="blue-grey-lighten-1"
              @click="$router.go(-1)"
              icon="mdi mdi-step-backward"
            ></v-icon>
          </v-col>
          

          <v-col md="7" cols="10" class="pa-0 align-self-center">
            <v-row>
              <v-col cols="4" class="align-self-center">
                <v-autocomplete
                  label="Company"
                  variant="outlined"
                  density="compact"
                  single-line
                  hide-details="auto"
                  bg-color="grey-lighten-4"
                  v-model="selectedCompany"
                  :items="getCompanyList.filter((item) => item.status == 1)"
                  :item-title="(item) => `${item.name} - ${item.code}`"
                  item-value="id"
                  :disabled="getCompanyList.length == 1"
                  :loading="company_loading"
                  autocomplete="off"
                ></v-autocomplete>
              </v-col>

              <v-col cols="3" class="align-self-center px-0">
                <v-autocomplete
                  label="Branch"
                  variant="outlined"
                  density="compact"
                  single-line
                  hide-details="auto"
                  bg-color="grey-lighten-4"
                  v-model="selectedBranch"
                  :items="
                    getBranchList.filter(
                      (item) => item.company_id == this.selectedCompany
                    )
                  "
                  :item-title="(item) => `${item.name} - ${item.code}`"
                  item-value="id"
                  :loading="branch_loading"
                  :disabled="getBranchList.length == 1"
                  autocomplete="off"
                  @update:modelValue="
                    (value) => {
                      this.tempId = value;
                      this.switchBranch(this.tempId);
                    }
                  "
                ></v-autocomplete>
              </v-col>

              <v-col cols="1" class="text-center align-self-center">
               
                <div class="text-center">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    location="end"
                  >
                    <!-- <template v-slot:activator="{ props }">
                      <div
                        v-bind="props"
                        class="pa-2"
                        style="
                          border-radius: 50%;
                          height: 40px;
                          width: 40px;
                          background-color: #f5f5f5;
                        "
                      >
                        <v-badge content="1" color="red">
                          <v-icon icon="mdi mdi-bell" size="small"></v-icon>
                        </v-badge>
                      </div>
                    </template> -->

                    <v-card min-width="300">
                      <v-list>
                        <v-list-item title="Notifications"></v-list-item>
                      </v-list>
                      <v-divider></v-divider>

                      <v-list> </v-list>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn variant="text" @click="menu = false">
                          Mark as read
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="3" class="align-self-center">
                <div class="text-subtitle-2 text-right">
                  {{ user.fullName }}
                </div>
                <div class="text-caption text-right">{{ user.role_name }}</div>
              </v-col>

              <v-col cols="1" class="text-left">
                <v-menu min-width="200px" rounded>
                  <template v-slot:activator="{ props }">
                    <v-btn icon v-bind="props">
                      <v-avatar
                        icon="$vuetify"
                        :image="getFileServerUrl + (user.imageThumb != null ? user.imageThumb : 'uploads/demo_images/user.png') "
                        size="40"
                      ></v-avatar>
                    </v-btn>
                  </template>

                  <v-card
                    class="mx-auto pa-4"
                    elevation="2"
                    max-width="auto"
                    rounded="lg"
                  >
                    <v-card-text>
                      <div class="mx-auto text-center">
                        <v-avatar
                          icon="$vuetify"
                          :image="
                            getFileServerUrl +
                            (user.imageThumb != null
                              ? user.imageThumb
                              : 'uploads/demo_images/user.png')
                          "
                          size="40"
                        ></v-avatar>
                        <h3>{{ user.fullName }}</h3>
                        <p class="text-caption mt-1">
                          {{ user.role_name }}
                        </p>
                        <v-divider class="my-1"></v-divider>
                        <v-btn
                          variant="text"
                          prepend-icon="mdi mdi-lock-reset"
                          class="icon-size-24"
                          @click="goTo('/administration/change-password')"
                        >
                          Change Password
                        </v-btn>
                        <v-divider class="my-1"></v-divider>
                        <v-btn
                          color="error"
                          variant="text"
                          prepend-icon="mdi mdi-logout"
                          @click="logout"
                        >
                          Log out
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import navBar from "./navBar.vue";
import { ref } from "vue";
import loading from "@/components/utils/loading.vue";
import confirm from "@/components/utils/confirm.vue";
import { toast } from "vue3-toastify";
import breadCrumbs from "@/components/utils/breadCrumbs.vue";
//  const drawer = ref(null)
export default {
  components: {
    navBar,
    loading,
    breadCrumbs,
    confirm,
  },
  data: () => ({
    drawer: true,
    fav: true,
    menu: false,
    message: true,
    hints: true,
    selectedBranch: null,
    selectedCompany: null,
    branch_loading: true,
    company_loading: true,
    user: {
      firstName: "",
      fullName: "",
      lastName: "",
      mobile: "",
      image: "",
      imageThumb: "",
      email: "",
      branch_id: null,
      role_name: "",
    },
    navigation: {
      shown: false,
    },
    currentBranch: {
      id: null,
      name: "",
      code: "",
      company: {
        id: null,
        name: "",
        code: "",
      },
    },
  }),
  created() {
    this.$store.dispatch("getCompanyList").then((data) => {
      this.company_loading = false;
      this.selectedCompany = parseInt(this.currentBranch.company.id);
    });

    this.$store.dispatch("getBranchList").then((data) => {
      this.branch_loading = false;
      this.selectedBranch = parseInt(this.currentBranch.id);
    });
  },
  watch: {
    selectedCompany(val) {
      this.selectedBranch = null;
    },
    "$route.path"(val) {
      if(val==='/module/documents'){
        this.navigation.shown = false;
      }else{
        this.navigation.shown = true;
      }
    }
  },
  computed: {
    getMessage() {
      return this.$store.getters.getMessage;
    },
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany;
    },
    getSidebarCollapse() {
      return this.$store.getters.getSidebarCollapse;
    },
    getCompanyList() {
      return this.$store.getters.getCompanyList.filter(
        (item) => item.status == 1
      );
    },
    getBranchList() {
      return this.$store.getters.getBranchList.filter(
        (branch) => branch.status == 1
      );
    },
    getCurrentBranch() {
      return this.$store.getters.getCurrentBranch;
    },
    getAuthUser() {
      return this.$store.getters.getAuthUser;
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },
  methods: {
    logout() {
      let self = this;
      this.$root
        .$confirm("Are you sure you want to log out?", {
          color: "red",
          item: "Logout",
        }).then((confirm) => {
          if (confirm) {
            self.$store
              .dispatch("logoutUser")
              .then(function (response) {
                self.$router.push("/");
              })
              .catch(function (error) {
                console.log("error", error);
                toast.error("Something Went Wrong!");
              });
          }
        });
    },
    getLoad() {
      this.$store.commit("SET_LOADING", { color: "indigo" });
    },
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    switchBranch(id) {
      const selectedBranchInfo = this.getBranchList.find(
        (item) => item.id == id
      );
      const title = selectedBranchInfo.title;
      let self = this;
      this.$root
        .$confirm("Are you sure that you want to switch?", {
          color: "info",
          item: title,
        })
        .then((confirm) => {
          if (confirm) {
            this.$store
              .dispatch("changeBranch", { branch_id: selectedBranchInfo.id })
              .then(function (response) {
                self.goTo("/home/dashboard");
                toast.success(response.data.message);
              })
              .catch(function (error) {
                console.log("error", error);
                toast.error(error.response.data.message);
              });
          } else {
            let users_info = self.getAuthUser;
            self.selectedCompany = parseInt(users_info.company_id);
            self.$nextTick(() => {
              self.selectedBranch = parseInt(users_info.branch_id);
            });
          }
        });
    },
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    let user_info = this.getAuthUser;

    this.user.imageThumb = user_info.image_thumb;
    this.user.fullName = user_info.full_name;
    this.user.email = user_info.email;
    this.user.role_name = user_info.role_name;

    this.currentBranch = this.getCurrentBranch;
    this.selectedBranch = this.currentBranch.id;
    this.selectedCompany = this.currentBranch.company.id;

    if (!this.getCompanyList.length) {
      this.selectedCompany = null;
    }
    if (!this.getBranchList.length) {
      this.selectedBranch = null;
    }
  },
};
</script>

<style>
  .v-toolbar-title__placeholder {
    overflow: unset !important;
  }
</style>
